import widgetsApi from "../../services/api/WidgetsApi";

const actions = {
  async getAllWidgets({ commit }) {
    let err, response;
    try {
      [err, response] = await widgetsApi.getAllWidgets();
      if (!err) {
        commit("SET_WIDGETS", response.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },
  async getAllAllWidgets({ commit }, isPaginate) {
    let err, response;
    try {
      [err, response] = await widgetsApi.getAllAllWidgets(isPaginate);
      if (!err) {
        commit("SET_WIDGETS_ALL", response.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },
  getWidgetById({ commit }, id) {
    if (id !== "0") {
      return widgetsApi.getWidgetById(id).then(response => {
        commit("SET_WIDGET", response);
        return response;
      });
    }
  },
  deleteById({ commit }, id) {
    return widgetsApi
      .deleteById(id)
      .then(response => commit("SET_FORM", response));
  },
  async getWidgetsByPage({ commit }, page) {
    let err, response;
    try {
      [err, response] = await widgetsApi.getWidgetsByPage(page);

      if (!err) {
        commit("SET_WIDGETS", response.data);
        return response;
      }
    } catch (e) {
      console.log(e);
    }
  },
  async getPageByName({ commit }, data) {
    let err, response;
    try {
      [err, response] = await widgetsApi.getPageByName(data.slug, data.lang);
      if (!err) {
        commit("SET_PAGE_BY_NAME", response.data);
        return response.data.data;
      }
    } catch (e) {
      console.log(e);
    }
  }
};

export default actions;
